module.exports = __webpack_public_path__ + "img/20190528161952587.4c83c352.png";